export default __webpack_public_path__ + "static/media/logo.69a7a9d5.png";